export default __webpack_public_path__ + "static/media/AGC_2022_R2_QP_Class_3.a1183192.pdf";